import React,{useEffect, useRef} from 'react'
import { useState } from 'react'

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';


import { Print } from '@mui/icons-material';


import attendanceServices from '../attendanceServices';
import DateSelect from '../../../../../components/AppInput/DateSelect';
import AppLayout from '../../../../../layout/components/AppLayout';
import { useAppData } from '../../../../../context/AppDataContext';





function AllWorkReportList() {

  const {employeeDD, getMasterLabel, getDDDataById} = useAppData();
  const [filter,setFilter] = useState(null);
  const [workReportList,setWorkReportList] = useState(null);
  const gridRef = useRef();
  

  const getWorkReport = () =>{
    attendanceServices.getWorkReportListAll(filter).then(res=>{
      setWorkReportList(res.data)
    }).catch(error=>{
      console.log(error);
    })
  }

  const remove = () =>{

  }

  const [defaultColDef] = useState({
    floatingFilter: true,
    filterParams: {
      buttons: ['apply'],
    },
    resizable: true,
    width:120,
    filter:true,
    sortable: true,
    cellStyle: { 'textTransform': 'uppercase' },
  });


  const [columnDefs,setColumnDef] = useState();
    const prepairColumnDef = () => {
    let _columnDefs = [
        {field:"id",headerName: "ID"},
        {headerName: "E. Name", width:150,
          valueGetter:params=>{
            return getDDDataById(employeeDD,params.data.employeeId).label
          }
        },
        {field:"report",headerName: "report",width:800},
        {field:"updated_at",headerName: "Date",width:200},
   
    ];
    setColumnDef(_columnDefs);
  }

  const onBtnExport = () => {
    gridRef.current.api.exportDataAsCsv("data.csv");
  };

  useEffect(()=>{
    getWorkReport();
  },[filter])

  useEffect(()=>{    
    prepairColumnDef();
  },[]);
  return (
        <div className='row'>
          <div className='col-md-6'><h4>Daily Work report</h4></div>
          <div className='col-md-6'>
            <DateSelect filter={filter} setFilter={setFilter} /> 
            <button className='btn btn-warning me-2 float-end' onClick={onBtnExport} ><Print /> Export </button>
          </div>
          <div className='col-md-12 mt-2'>
            <div className="ag-theme-alpine" style={{height: 400}}>
                <AgGridReact
                  ref={gridRef}
                  rowData={workReportList}
                  columnDefs={columnDefs}
                  defaultColDef={defaultColDef}
                  animateRows={true}
                  onGridReady={getWorkReport}
                />
              </div>
            </div>
          </div>
    
    
  )
}

export default AllWorkReportList